// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--iz415";
export var childFlex = "index-module--childFlex--EQLf5";
export var childShrink = "index-module--childShrink--KiB3y";
export var container = "index-module--container--JHSzA";
export var ctaTextLink = "index-module--ctaTextLink--K4nyG";
export var descriptionBlock = "index-module--descriptionBlock--3GQXp";
export var hasImage = "index-module--hasImage--3uoNK";
export var imageBox = "index-module--imageBox--XoTNQ";
export var isChinese = "index-module--isChinese--aJ4JD";
export var label = "index-module--label--bAaxr";
export var labelNew = "index-module--labelNew--KIhXj";
export var subtitle = "index-module--subtitle--Rmmfn";